import useResizeObserver from '@react-hook/resize-observer';
import debounce from 'lodash.debounce';
import * as React from 'react';

export const useSize = (target: React.RefObject<HTMLElement>) => {
  const [size, setSize] = React.useState<DOMRect>();

  React.useLayoutEffect(() => {
    debounce(
      () => {
        if (target.current) setSize(target.current.getBoundingClientRect());
      },
      1000,
      { leading: true, trailing: false },
    );
  }, [target]);

  useResizeObserver(target, (entry) => setSize(entry.contentRect));

  return size;
};
